import * as Morphic from '@morphic-ts/adt';
import { pipe, tuple } from 'fp-ts/function';
import * as RNEA from 'fp-ts/ReadonlyNonEmptyArray';
import * as RR from 'fp-ts/ReadonlyRecord';
import * as S from 'fp-ts/Semigroup';
export function fromUnion(tag, u) {
    return pipe(RR.fromFoldableMap(S.first(), RNEA.Foldable)(u.types, function (type) {
        return tuple(type.props[tag].value, Morphic.ofType());
    }), Morphic.makeADT(tag));
}
